import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useRealmApp } from "../RealmApp";
import { useMemo } from "react";
import { useDatesContext } from "context/DatesContext";

const useXReports = (storeId, range) => {
  const app = useRealmApp();
  const { xReports, loading } = useAllXReports(
    app.currentUser.id,
    storeId,
    range.start,
    range.end
  );
  return {
    loading,
    xReports,
  };
};

export default useXReports;

function useAllXReports(ownerId, storeId, start, end) {
  const xReportDateInput = {
    storeId,
    start,
    end,
  };
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl("useAllXReports", 60 * 1000);
  //console.log("fetchPolicy", fetchPolicy);
  //
  const { data, loading, error } = useQuery(
    gql`
      query GetXReportDate($xReportDateInput: XReportDateInput!) {
        xReportDate(input: $xReportDateInput) {
          _id
          cardAmount
          cardQuantity
          cashAmount
          cashEndAmount
          cashQuantity
          cashStartAmount
          closeDatetime
          closeUserId
          closeUserName
          commissions
          creBase
          creEndNumber
          creQuantity
          creStartNumber
          creTotal
          creationDatetime
          discountAmount
          discountQuantity
          discountRefundAmount
          discountRefundQuantity
          facBase
          facEndNumber
          facQuantity
          facStartNumber
          facTotal
          itemQuantity
          itemRefundQuantity
          mode
          openUserId
          openUserName
          otherAmount
          otherEndAmount
          otherQuantity
          otherStartAmount
          payments
          reportNumber
          status
          storeId
          subcategories
          taxes
          terminalId
          terminalSerial
          type
          updateDatetime
          users
          withdrawals
        }
      }
    `,
    {
      variables: {
        xReportDateInput,
      },
      fetchPolicy,
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  // console.log("************** data", data, start, end, ownerId, storeId);
  let xReports = useMemo(() => data?.xReportDate ?? [], [data]);

  if (!Array.isArray(xReports)) {
    xReports = [xReports];
  }

  const sortedXReports = useMemo(() => {
    return xReports
      .slice()
      .sort((a, b) => new Date(b.updateDatetime) - new Date(a.updateDatetime));
  }, [xReports]);

  return { xReports: sortedXReports, loading };
}
